// extracted by mini-css-extract-plugin
export var radioInputRow = "w_sH";
export var radioInputColumn = "w_sJ";
export var inputOptionRow = "w_r5";
export var inputOptionColumn = "w_r6";